import config from 'config';
import axios from 'axios';
import FileSaver from 'file-saver';

const ROOT = config.API_BASE_URL;

class PastChecklistsService {

  static get(pastChecklistId, replaceWithMostRecent = false) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/past/${pastChecklistId}?replaceWithMostRecent=${replaceWithMostRecent}`).then(response => {
        resolve({ checklist: response.data, response: response });
      }).catch(err => {
        reject(err);
      });
    });
  }

  static getForGrouping(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}checklists/past${params}`).then((data) => {
        resolve({ checklists: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getSummaryReport(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}reports/checklist-summary-report${params}`).then((response) => {
        resolve({ checklistEntries: response.data, response: response });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getSummaryReportCSV(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}reports/checklist-summary-report-csv${params}`).then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        FileSaver.saveAs(blob, 'report.csv');
        resolve();
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getCorrectiveActionReport(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}reports/corrective-actions-report${params}`).then((response) => {
        resolve({ report: response.data, response: response });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllChecklistsReport(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}reports/all-checklist-report${params}`).then((response) => {
        resolve({ report: response.data, response: response });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getLocationChecklistDashboardPastData(locationId, options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}dashboards/checklist/location/${locationId}${params}`).then((response) => {
        resolve({ report: response.data, response: response, options: options });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getLocationChecklistDashboardAvailableData(locationId, options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}dashboards/checklist/location/${locationId}/available${params}`).then((response) => {
        resolve({ availableChecklists: response.data, response: response, options: options });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getPastChecklistPassiveReportData(startAtDate, endAtDate) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}reports/passive-checklist-report?startDate=${startAtDate}&endDate=${endAtDate}`).then(response => {
        resolve({ report: response.data, response: response });
      }).catch(err => {
        reject(err);
      });
    });
  }

}

export default PastChecklistsService;